module.exports = __webpack_public_path__ + "img/4-consumers-and-stylists-tape.png";